module.exports = __webpack_public_path__ + "img/down-chevron.0c9423c3.svg";